// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__L_6FU","alertIcon":"ConfirmModal_alertIcon__3NTwE"};